import {
  TOTPInput
} from "./chunk-NKYIFJDS.mjs";

// src/internal/components/totp-panel/totp-panel-content.tsx
import { Box, Stack, Typography } from "@mui/material";
import { useT } from "@clara/locale";
import { jsx, jsxs } from "react/jsx-runtime";
var TotpPanelContent = () => {
  const { t } = useT("auth");
  return /* @__PURE__ */ jsxs(Stack, { spacing: 4, children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        component: "img",
        src: "https://clara-all-assets-prod.s3.amazonaws.com/security.svg",
        sx: {
          height: "160px"
        }
      }
    ),
    /* @__PURE__ */ jsxs(Stack, { spacing: 2, children: [
      /* @__PURE__ */ jsx(Typography, { variant: "h2", fontWeight: 600, children: t("totp.sidepanel.headline") }),
      /* @__PURE__ */ jsx(Typography, { variant: "body1", children: t("totp.sidepanel.tagline") })
    ] }),
    /* @__PURE__ */ jsx(TOTPInput, {})
  ] });
};

export {
  TotpPanelContent
};
